import Font from "@/src/components/base/Font";
import style from "./style.module.scss";
export type ButtonBaseProps = {
  text: string;
};

export default function ButtonBase({
  children,
  variant = "primary",
  enabled = true,
  size = "wide",
  type = "button",
  capitalize = false,
  text = "",
  id = "",
  onClick,
}: {
  children?: JSX.Element;
  text?: string;
  type?: "button" | "submit" | "reset";
  variant?: "primary" | "secondary" | "tertiary";
  capitalize?: boolean;
  size?: "wide" | "modal" | "half" | "action" | "medium";
  enabled?: boolean;
  id?: string;
  onClick?: () => void;
}): JSX.Element {
  const handleClick = () => {
    if (onClick) {
      onClick();
    }
  };
  return (
    <button
      id={id}
      type={type}
      onClick={enabled ? () => handleClick() : (e) => e.preventDefault()}
      className={`${style.button} ${
        style["button--" + variant + "-" + (enabled ? "enabled" : "disabled")]
      } ${style["button--" + size]} `}
    >
      {children}
      <Font
        variant={"button-1-bold"}
        align="center"
        color={variant === "primary" ? "white" : "orange1"}
      >
        {capitalize ? text?.toUpperCase() : text}
      </Font>
    </button>
  );
}
